<template>
    <div>
      <app-header class="haeder-r"></app-header>
        <!--slider end -->

        <div class="box-title">
            <h2 v-lang.umbrellatext></h2>
        </div>
        <section class="full-page gallery" >
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-12 col-xs-12 col-sm-12 ">
                        <div class="box-title">
                            <p v-lang.umbrelladesc>
                            </p>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="box-filter">
                                <ul class="text-center ">
                                  <li>
                                    <a class="button is-checked" @click="toggle('all')" v-lang.all></a>
                                </li>
                                    <li v-if="! valid(category.slug)"  v-for="category in categories"><a @click="toggle(category.name)">{{category.name}}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <ul class="ul-gallery">
                        <li v-for="project in projects" v-show="selected(project)" class="col-xs-12 col-sm-6 col-lg-3 col-md-4">
                         <div class="box-li">
                            <a :href="/project/+project.slug">
                                <div class="box-img" :style="'background-image: url('+ project.image +')'"></div>
                                <div class="box-text">
                                <h3>{{project.title}}</h3>
                                </div>
                            </a>
                         </div>
                        </li>
                    </ul>
                  <div class="clearfix"></div>
                   <button @click="loadMore()" class="load-more" v-if="this.pagination.next && this.pagination.next !== null">Load More <i v-if="loading" class="fa fa-spin fa-spinner"></i></button>
                </div>
            </div>
        </section>
      <app-footer></app-footer>
    </div>
</template>
<script>
import {Urls,checkForDub,apiDomain} from '../config'
  export default {
    mounted(){
        //  $(".lightgallery").lightGallery()
        this.getProjects()
            $('.carousel').carousel();

    },
    data(){
      return {
        loading : false,
        cat : [],
        type : 'all',
         loading : false,
        pagination : {},
         mainCat : ['engineering-department','muhendislik-bolumu','ksm-alhndsy','ksm-almthlat-oalaaraesh','golge-sistemleri-bolumu','department-of-awnings']
      }
    },
    methods: {
        valid(data){
              return inArray(this.mainCat,data)
        },
        openGallery(images){
            var $lg = $('#dynamic');
            let gal = images
            gal.forEach(image => {
                image.src = image.img
            })
                var lg = $lg.lightGallery({
                    dynamic: true,
                    dynamicEl: gal,
                });
                lg.one("onCloseAfter.lg", function() {
                    lg.data('lightGallery').destroy(true);
                });
        },
        getProjects(){
           this.loading = true
              let link = apiDomain + '/api/category/projects/ksm-almthlat-oalaaraesh?language='+this.language
          if( this.pagination.next){
               link = this.pagination.next
          }
          this.axios.get(link)
              .then((response) => {
              // Success
              this.loading = false
              if(response.status === 200){
                   this.pagination = response.data.links
                  response.data.data.forEach(project => {
                  if(! checkForDub(this.projects,project,'slug')){
                      this.$store.commit('projects/add', project)
                  }
                  })
              }
              }).catch((errors) => {
              // error
              this.loading = false
              console.log(errors)
              this.err = errors
          })
      },
      toggle(selected){
            if(selected == 'all'){
                this.type = 'all'
            }
            if(selected === 'hide'){
                this.type = false
            }
            this.type = selected
      },
      selected(project){
            if(this.type === 'all'){
                return true
            }
            for(var i = 0; i < project.category.length; i++) {
                if(project.category[i].name === this.type) {
                    return true;
                }
            }
            return false;
      },
        loadMore(){
          this.getProjects()
      }
    },
    computed:{
        projects(){
            return this.$store.state.projects.projects
        },
        categories(){
            this.projects.forEach(project => {
                   project.category.forEach(category => {
                        if(! checkForDub(this.cat,category,'id')){
                            this.cat.push(category)
                        }
                    })
            })
            return this.cat
        }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/umbrella.vue